/**
 * Indicates the preferred method of communication (used for relationship scoring)
 */
export enum CommsPreference {
  EMAIL = '1',
  CALL = '2',
  MEETING = '3',
}

/**
 * Indicates the frequency of contact that should be maintained
 */
export enum EntropyPeriod {
  MONTHLY = '2',
  QUARTERLY = '4',
  HALFYEARLY = '6',
}
